import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { GetTextPipe } from 'src/app/pipes';

@Component({
  selector: 'app-view-observations-base',
  template: `
    <p>
      view-observations-base will never be shown!
    </p>
  `,
  styles: [
  ]
})
export class ViewObservationsBaseComponent implements OnInit {

 public tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    export: false
  }
  public tableHeader: AimsCommonTableHeader[] = [
    { key: 'details', label: 'Details', type: 'button', prefix: '/projectSupport/observation/', linkId: 'observationId', filter: false, },
    { key: 'obsInspNum', label: 'Insp Number', type: 'string', width: 100 },
    { key: 'openedDate', label: 'Opened', type: 'date', width: 70},
    { key: 'area', label: 'Area', type: 'string', },
    { key: 'discrepancy', label: 'Discrepancy', type: 'dynamic', width: 400 },
    { key: 'responsibleManager', label: 'Responsible Manager', type: 'string', },
    { key: 'projMngrReviewedDate', label: 'Closed On', type: 'date', width: 70},
    { key: 'managerEstCompDate', label: 'Mgr Est Comp', type: 'date', width: 70},
    { key: 'finalReviewDate', label: 'Closed On', type: 'date', width: 70},
    { key: 'workSection', label: 'Work Section', type: 'string', },
    { key: 'pwsReference', label: 'PWS Ref', type: 'string', },
    { key: 'pwsRefDesc', label: 'PWS Ref Desc', type: 'dynamic', width: 300 },
    { key: 'altReference', label: 'Alt Ref', type: 'string', width: 70 },
    { key: 'altRefDesc', label: 'Alt Ref Desc', type: 'dynamic', width: 300 },
    { key: 'pubReferenceId', label: 'Pub Ref', type: 'dynamic',  filterType: 'dynamic', width: 150,
      events: { filterAndSortCompare: (term, el) => term === el.pubReferenceId } },
    { key: 'pubRefDesc', label: 'Pub Ref Desc', type: 'string', width: 400 },
    { key: 'siteCode', label: 'Site', type: 'string', },
    { key: 'deficiencyType', label: 'Deficiency Type', type: 'string', },
    { key: 'observationType', label: 'Obs Type', type: 'string', },
    { key: 'inspectionDate', label: 'Inspection Date', type: 'date', width: 70},
    { key: 'workSectionSuspenseDate', label: 'WS Suspense Date', type: 'date', width: 70},
    { key: 'workSectionCompDate', label: 'WS Comp Date', type: 'date', width: 70},
    { key: 'managerCompDate', label: 'Mgmt Comp Date', type: 'date', width: 70},
  ];

  public observations: Observable<any>;
  public isCar: boolean;
  public isOpen: boolean;
  public hideReferences: boolean = true;

  pubValues = this.transferHttp.getSingle('QualityControl/GetPublicationsForPopUp');

  constructor(public transferHttp: TransferHttpService, public getTextPipe: GetTextPipe) { }

  ngOnInit(): void {
  }

  setFlags(isCar: boolean, isOpen: boolean) {
    this.isCar = isCar;
    this.isOpen = isOpen;
    this.hideTableColumns();
    this.updateTablePermissions();
  }

  updateTablePermissions() {
    this.tablePermissions.export = ((this.isCar && this.isOpen) || !this.isCar);
  }

  hideTableColumns() {
    var column = this.tableHeader.find(el => el.key == 'projMngrReviewedDate');
    column.hidden = !this.isCar || this.isOpen;

    column = this.tableHeader.find(el => el.key == 'managerEstCompDate');
    column.hidden = !this.isCar || !this.isOpen;

    column = this.tableHeader.find(el => el.key == 'finalReviewDate');
    column.hidden = this.isCar || this.isOpen;

    // show/hide references
    column = this.tableHeader.find(el => el.key == 'pwsReference');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'pwsRefDesc');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'altReference');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'altRefDesc');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'pubReferenceId');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'pubRefDesc');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'siteCode');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'deficiencyType');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'observationType');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'inspectionDate');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'workSectionSuspenseDate');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'workSectionCompDate');
    column.hidden = this.hideReferences;
    column = this.tableHeader.find(el => el.key == 'managerCompDate');
    column.hidden = this.hideReferences;

    this.tableHeader = [...this.tableHeader];
  }

  toggleHidden(): void {
    this.hideReferences = !this.hideReferences;
    this.hideTableColumns();
  }

  public excelReportName: string = 'Observations_Export.xlsx';

  getForExcel = (data: any) => {
    var pubVals: Array<object>;
    this.pubValues.pipe(take(1)).subscribe(p => {
      pubVals = p;
    });

    var exportData = data.map(r => {
      var x = {
        'obsInspNum': r.obsInspNum,
        'openedDate': r.openedDate,
        'area': r.area,
        'discrepancy': r.discrepancy,
        'responsibleManager': r.responsibleManager,
        'projMngrReviewedDate': r.projMngrReviewedDate,
        'managerEstCompDate': r.managerEstCompDate,
        'finalReviewDate': r.finalReviewDate,
        'workSection': r.workSection,
        'pwsReference': r.pwsReference,
        'pwsRefDesc': r.pwsRefDesc,
        'altReference': r.altReference,
        'altRefDesc': r.altRefDesc,
        'pubReferenceId': this.getTextPipe.transform(r.pubReferenceId, 'publicationId','pubNum', pubVals),
        'pubRefDesc': r.pubRefDesc,
        'siteCode': r.siteCode,
        'deficiencyType': r.deficiencyType,
        'observationType': r.observationType,
        'inspectionDate': r.inspectionDate,
        'workSectionSuspenseDate': r.workSectionSuspenseDate,
        'workSectionCompDate': r.workSectionCompDate,
        'managerCompDate': r.managerCompDate,
      };
      return x;
    });
    return { 'data': exportData, 'fileName':  this.excelReportName };
  }

  obsNotLoaded(): boolean {
    return this.observations === undefined;
  }

}
